import { t } from "i18next";
import { isEmpty, startCase } from "lodash";
import moment from "moment";
import React, { useState } from "react";

const TransactionRecordFilter = ({ setFilter, filter, getData }) => {
  const [show, setShow] = useState(false);
  return (
    <app-search-tab
      _ngcontent-serverapp-c3748548866
      _nghost-serverapp-c2684251700
      className="ng-tns-c2684251700-18 ng-tns-c3748548866-17 ng-star-inserted"
    >
      <div
        _ngcontent-serverapp-c2684251700
        className="ng-tns-c2684251700-18 ng-trigger ng-trigger-staggerFadeAnimation tab filter-tab ng-star-inserted"
      >
        <ul
          _ngcontent-serverapp-c2684251700
          className="item-ani ng-tns-c2684251700-18"
        >
          {" "}
          {!isEmpty(filter?.date) && (
            <li
              _ngcontent-serverapp-c2684251700
              className="active ng-tns-c2684251700-125 ng-star-inserted"
            >
              {startCase(filter?.date)}
            </li>
          )}
          {filter?.payment?.length > 0 &&
            filter?.payment?.map((res) => {
              return (
                <li
                  _ngcontent-serverapp-c2684251700
                  className="active ng-tns-c2684251700-125 ng-star-inserted"
                >
                  {startCase(res)}
                </li>
              );
            })}
          {filter?.status?.length > 0 &&
            filter?.status?.map((res) => {
              return (
                <li
                  _ngcontent-serverapp-c2684251700
                  className="active ng-tns-c2684251700-125 ng-star-inserted"
                >
                  {startCase(res)}
                </li>
              );
            })}
        </ul>
        <div
          onClick={() => {
            setShow(true);
          }}
          _ngcontent-serverapp-c2684251700
          className="btn search-btn ng-tns-c2684251700-18 ng-star-inserted"
        >
          <span
            _ngcontent-serverapp-c2684251700
            className="item-icon ng-tns-c2684251700-18 ng-star-inserted"
            style={{
              "mask-image": 'url("/assets/Icon/games-filter-icon.svg")',
            }}
          />
        </div>
      </div>

      <div
        _ngcontent-serverapp-c2684251700
        className={`searchpage ng-tns-c2684251700-18 ng-star-inserted ${
          show ? "active" : ""
        } `}
      >
        <div
          _ngcontent-serverapp-c2684251700
          className="search-top-info ng-tns-c2684251700-18"
        >
          <h6
            _ngcontent-serverapp-c2684251700
            className="ng-tns-c2684251700-18 ng-star-inserted"
          >
            {t("TransactionRecordFilter")}
          </h6>

          <div
            onClick={() => {
              setShow(false);
              getData();
            }}
            _ngcontent-serverapp-c2684251700
            className="back ng-tns-c2684251700-18"
            style={{
              "mask-image": 'url("/assets/Icon/icon-arrow-type01.svg")',
            }}
          >
            Back
          </div>
        </div>
        <div
          _ngcontent-serverapp-c2684251700
          className="searchpage-main ng-tns-c2684251700-18"
        >
          <div
            _ngcontent-serverapp-c2684251700
            className="search-checkbox-group check-group ng-tns-c2684251700-18 ng-star-inserted"
          >
            <h2
              _ngcontent-serverapp-c2684251700
              className="ng-tns-c2684251700-18 ng-star-inserted"
            >
              {t("Status")}
            </h2>

            <ul
              _ngcontent-serverapp-c2684251700
              className="ng-tns-c2684251700-18"
            >
              {statusOptions?.map((res) => {
                return (
                  <li
                    onClick={() =>
                      setFilter((prev) => {
                        return {
                          ...prev,
                          status: prev?.status?.includes(res?.value)
                            ? prev?.status?.filter((item) => {
                                return res?.value != item;
                              })
                            : [...prev?.status, res?.value],
                        };
                      })
                    }
                    _ngcontent-serverapp-c2684251700
                    className="ng-tns-c2684251700-18 ng-star-inserted"
                  >
                    <input
                      _ngcontent-serverapp-c2684251700
                      className="ng-tns-c2684251700-18"
                      type="checkbox"
                      checked={filter?.status?.includes(res?.value)}
                    />
                    <label
                      _ngcontent-serverapp-c2684251700
                      className="ng-tns-c2684251700-18"
                    >
                      <span
                        _ngcontent-serverapp-c2684251700
                        className="ng-tns-c2684251700-18"
                      >
                        {res?.label}
                      </span>
                      <i
                        _ngcontent-serverapp-c2684251700
                        className="ng-tns-c2684251700-18"
                        style={{
                          "background-image": 'url("/assets/Other/check.svg")',
                        }}
                      />
                    </label>
                  </li>
                );
              })}
            </ul>
          </div>
          <div
            _ngcontent-serverapp-c2684251700
            className="search-checkbox-group check-group ng-tns-c2684251700-18 ng-star-inserted"
          >
            <h2
              _ngcontent-serverapp-c2684251700
              className="ng-tns-c2684251700-18 ng-star-inserted"
            >
              {t("PaymentType")}
            </h2>

            <ul
              _ngcontent-serverapp-c2684251700
              className="ng-tns-c2684251700-18"
            >
              {transactionOptions?.map((res) => {
                return (
                  <li
                    onClick={() =>
                      setFilter((prev) => {
                        return {
                          ...prev,
                          payment: prev?.payment?.includes(res?.value)
                            ? prev?.payment?.filter((item) => {
                                return res?.value != item;
                              })
                            : [...prev?.payment, res?.value],
                        };
                      })
                    }
                    _ngcontent-serverapp-c2684251700
                    className="ng-tns-c2684251700-18 ng-star-inserted"
                  >
                    <input
                      _ngcontent-serverapp-c2684251700
                      className="ng-tns-c2684251700-18"
                      type="checkbox"
                      checked={filter?.payment?.includes(res?.value)}
                    />
                    <label
                      _ngcontent-serverapp-c2684251700
                      className="ng-tns-c2684251700-18"
                    >
                      <span
                        _ngcontent-serverapp-c2684251700
                        className="ng-tns-c2684251700-18"
                      >
                        {res?.label}
                      </span>
                      <i
                        _ngcontent-serverapp-c2684251700
                        className="ng-tns-c2684251700-18"
                        style={{
                          "background-image": 'url("/assets/Other/check.svg")',
                        }}
                      />
                    </label>
                  </li>
                );
              })}
            </ul>
          </div>
          <div
            _ngcontent-serverapp-c2684251700
            className="search-checkbox-group check-group ng-tns-c2684251700-18 ng-star-inserted"
          >
            <h2
              _ngcontent-serverapp-c2684251700
              className="ng-tns-c2684251700-18 ng-star-inserted"
            >
              {t("Date")}
            </h2>
            <ul
              _ngcontent-serverapp-c2684251700
              className="ng-tns-c2684251700-125"
            >
              {timeRanges?.map((res) => {
                return (
                  <li
                    onClick={() =>
                      setFilter((prev) => {
                        return {
                          ...prev,
                          date: res?.name,
                          fromPeriod:
                            res?.name == "Last 7 days"
                              ? moment(new Date())
                                  .subtract(7, "days")
                                  .format("YYYY-MM-DD")
                              : res?.name == "Yesterday"
                              ? moment(new Date())
                                  .subtract(1, "days")
                                  .format("YYYY-MM-DD")
                              : moment(new Date()).format("YYYY-MM-DD"),
                        };
                      })
                    }
                    _ngcontent-serverapp-c2684251700
                    className="ng-tns-c2684251700-125 ng-star-inserted"
                  >
                    <input
                      _ngcontent-serverapp-c2684251700
                      className="ng-tns-c2684251700-125"
                      type="radio"
                      checked={filter?.date == res?.name}
                    />
                    <label
                      _ngcontent-serverapp-c2684251700
                      className="ng-tns-c2684251700-125"
                    >
                      <span
                        _ngcontent-serverapp-c2684251700
                        className="ng-tns-c2684251700-125"
                      >
                        {res?.name}
                      </span>
                      <i
                        _ngcontent-serverapp-c2684251700
                        className="ng-tns-c2684251700-125"
                        style={{
                          "background-image": `url(${res?.icon})`,
                        }}
                      />
                    </label>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>

        <div
          onClick={() => {
            setShow(false);
            getData();
          }}
          _ngcontent-serverapp-c2684251700
          className="searchpage-bar ng-tns-c2684251700-18"
        >
          <div
            _ngcontent-serverapp-c2684251700
            className="button btn-primary ng-tns-c2684251700-18"
          >
            {t("Confirm")}
          </div>
        </div>
      </div>
    </app-search-tab>
  );
};

export default TransactionRecordFilter;

const statusOptions = [
  {
    label: "Processing",
    value: "processing",
    icon: "/assets/Other/check.svg",
  },
  {
    label: "Rejected",
    value: "rejected",
    icon: "/assets/Other/check.svg",
  },
  {
    label: "Approved",
    value: "approved",
    icon: "/assets/Other/check.svg",
  },
];

const transactionOptions = [
  {
    label: "Deposit",
    value: "deposit",
    icon: "/assets/Other/check.svg",
  },
  {
    label: "Withdrawal",
    value: "withdrawal",
    icon: "/assets/Other/check.svg",
  },
  {
    label: "Adjustment",
    value: "adjustment",
    icon: "/assets/Other/check.svg",
  },
];
const timeRanges = [
  {
    name: "Today",
    icon: "/assets/Other/check.svg",
  },
  {
    name: "Yesterday",
    icon: "/assets/Other/check.svg",
  },
  {
    name: "Last 7 days",
    icon: "/assets/Other/check.svg",
  },
];
